import React, { useEffect, useRef, useState } from 'react';
import { SplashScreen as CapSplashScreen } from '@capacitor/splash-screen';
import './SplashScreen.css';

// How long the animated brand splash stays before it fades into the app.
const HOLD_MS = 2200;
const FADE_MS = 600;

// Show the brand splash only once per app launch (not on every remount / hot reload).
let hasPlayed = false;

const SplashScreen = ({ children }) => {
  const [show, setShow] = useState(!hasPlayed);
  const [exiting, setExiting] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    // Always dismiss the native (static) splash immediately so our animated
    // HTML splash is what the user sees.
    CapSplashScreen.hide().catch(() => {});

    if (hasPlayed) return undefined;
    hasPlayed = true;

    timers.current.push(setTimeout(() => setExiting(true), HOLD_MS));
    timers.current.push(setTimeout(() => setShow(false), HOLD_MS + FADE_MS));

    return () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
  }, []);

  return (
    <>
      {show && (
        <div className={`ems-splash${exiting ? ' ems-splash--exit' : ''}`} role="status" aria-label="Loading Coach EMS">
          <div className="ems-splash__orb ems-splash__orb--1" />
          <div className="ems-splash__orb ems-splash__orb--2" />
          <div className="ems-splash__grid" />

          <div className="ems-splash__stage">
            <div className="ems-splash__glow" />
            <svg className="ems-splash__mark" viewBox="0 0 512 512" width="156" height="156" aria-hidden="true">
              <g className="ems-mark">
                <rect className="ems-bar ems-bar--spine" x="150" y="148" width="48" height="216" rx="24" />
                <rect className="ems-bar ems-bar--top" x="150" y="148" width="168" height="48" rx="24" />
                <rect className="ems-bar ems-bar--mid" x="150" y="232" width="118" height="48" rx="24" />
                <rect className="ems-bar ems-bar--bot" x="150" y="316" width="168" height="48" rx="24" />
                <path className="ems-arrow ems-arrow--line" d="M286 300 L322 264 L346 286 L392 232" pathLength="100" fill="none" />
                <path className="ems-arrow ems-arrow--head" d="M392 232 L356 230 M392 232 L394 268" pathLength="100" fill="none" />
              </g>
              <rect className="ems-shimmer" x="120" y="120" width="300" height="300" />
            </svg>
          </div>

          <div className="ems-splash__wordmark">
            <span className="ems-splash__brand">
              Coach<span className="ems-splash__brand-accent">EMS</span>
            </span>
            <span className="ems-splash__tagline">Employee Management System</span>
          </div>

          <div className="ems-splash__progress">
            <span />
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default SplashScreen;
